<template>
    <div class="timeline">
        <span :class="['step', {'active': step >= 1}]"></span>
        <span :class="['divider', {'active': step >= 2}]"></span>
        <span :class="['step', {'active': step >= 2}]"></span>
        <span :class="['divider', {'active': step >= 3}]"></span>
        <span :class="['step', {'active': step >= 3}]"></span>
        <span :class="['divider', {'active': step === 4}]"></span>
        <span :class="['step', {'active': step === 4}]"></span>
    </div>
</template>

<script setup>
    import { ref} from 'vue';
    const props = defineProps(["step"]);
    const step = ref(props.step);
    step.value = step.value + 1;
</script>

<style>

    .timeline {
        counter-reset: start 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
    }

        .timeline .step {
            list-style: none;
        }

        .timeline .divider {
            flex-grow: 1;
            border-bottom: 2px solid lightgray;
        }
        .timeline .divider.active {
            border-color: #0ED3C0;
        }

        .timeline:nth-child(1) {
            color: #4caf50;
        }

        .timeline .step:before {
            counter-increment: start;
            content: counter(start);
            width: 30px;
            height: 30px;
            border-radius: 50%;
            display: block;
            line-height: 30px;
        }

        .timeline .step:before {
            background-color: lightgray;
            color: white;
        }
        .timeline .step.active:before {
            background: #0ED3C0;
            color: white;
        }

        .timeline .step.active + .step:after {
            background: #4caf50;
        }
</style>